const domainUrl = {
  1: 'https://stubhub.community/t5/Events-and-Venues/NEW-Event-Request-for-StubHub-com/m-p/66320/highlight/true#M46432',
  2: 'https://www.stubhub.co.uk/request-event',
  3: 'https://www.stubhub.de/request-event',
  6: 'https://www.stubhub.es/request-event',
  10: 'https://www.stubhub.it/request-event',
};

export {domainUrl};
